export default __webpack_public_path__ + "static/media/714hz-toxin-cleanse.6d0fc8a6.jpg";